import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { memo, useMemo } from 'react';
import styles from './analyticsFilterSelectAll.module.scss';
export const AnalyticsFilterSelectAll = memo(function AnalyticsFilterSelectAll({ className, selectedValues, visibleValues, isDisabled, onChange, }) {
    const hasSelection = selectedValues.length > 0;
    const isDeterminate = useMemo(() => selectedValues.length === visibleValues.length &&
        visibleValues.every((item) => selectedValues.some(({ value }) => value === item.value)), [selectedValues, visibleValues]);
    const isIndeterminate = hasSelection && !isDeterminate;
    return (_jsxs("label", Object.assign({ className: classNames(className, styles.selectAll, {
            [styles.selectAllDisabled]: isDisabled,
        }) }, { children: [_jsx(Checkbox, { checked: isDeterminate, indeterminate: isIndeterminate, onChange: onChange, disabled: isDisabled }), _jsx(Text.Paragraph, { children: hasSelection ? 'Deselect all' : 'Select all' })] })));
});
